import React from 'react';
import { LogoContainer } from './styled';
import logoAlbo from './logo-albo.svg';
export const Logo = () => {
  return <LogoContainer src={logoAlbo} />;
};
